// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3rtwk","title":"Images90_title__3h0i4","images":"Images90_images__EjuyS"};